module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/title-switcher/title-switcher.component.scss
// module id = ./src/app/modules/common-module/components/title-switcher/title-switcher.component.scss
// module chunks = 9